import { useCreateUser } from 'src/admin/users/hooks/useCreateUser';

type SmartCreateUserInput = {
  firstName: string;
  lastName: string;
  emailAddress: string;
};

export function useSmartCreateUser(companyId: string | undefined) {
  const { createUser: createUserBase } = useCreateUser({ companyId });

  const createUser = async (input: SmartCreateUserInput) => {
    return createUserBase({
      ...input,
      userRole: 'ADVISOR',
      userStatus: 'ACTIVE',
    });
  };

  return { createUser };
}
